// Main.js
export const APP_TITLE = "Be Mithril.";
export const LOGOUT_BUTTON = "Logout";

// Routine.js
export const ADD_WEEK = "+ add a week";
export const ADD_ANOTHER_WEEK = "+ add another week";
export const DEFAULT_ROUTINE_NAME = "Enter Program Name";

// Week.js
export const ADD_WORKOUT = "+ add a workout";
export const ADD_ANOTHER_WORKOUT = "+ add another workout";

// Workout.js
export const ADD_EXERCISE = "+ add an exercise";
export const ADD_ANOTHER_EXERCISE = "+ add another exercise";

// ExerciseFullScreen.js
export const SETS = "sets";
export const REPS = "reps";
export const WEIGHT = "weight";
export const DEFAULT_PLACEHOLDER = "empty";

// EditText.js
export const CLICK_TO_EDIT = "Click to edit";
export const ENTER_KEYCODE = 13;

//All 
export const DEFAULT_PADDING = "16px";
export const DEFAULT_FONT_SIZE = "1rem";
export const FONT_SIZE_WEEK = "1.25rem";
export const FONT_SIZE_WORKOUT = "1.15rem";
export const FONT_SIZE_ROUTINE = "1.15rem";
export const FONT_SIZE_EXERCISE = ".85rem";